import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-intake-cancel-modal',
	templateUrl: './intake-cancel-modal.component.html',
	standalone: false,
})
export class IntakeCancelModalComponent {
	constructor(private dialogRef: MatDialogRef<IntakeCancelModalComponent>) {}

	onKeep(): void {
		this.dialogRef.close(false);
	}

	onCancel(): void {
		this.dialogRef.close(true);
	}
}
